var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import { inject, observer } from 'mobx-react';
import { EmailToScheduleBusiness } from '@business/emailToSchedule';
import { getUrlParams } from '@common/utils/url';
var TokenExpiredPage = /** @class */ (function (_super) {
    __extends(TokenExpiredPage, _super);
    function TokenExpiredPage() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = {
            isSendEmail: false,
            isSending: false,
            callCenter: '(888) 330-4969',
            isResidentScheduleOptimization: (_a = _this.props.location) === null || _a === void 0 ? void 0 : _a.pathname.includes("ResidentScheduleOptimization")
        };
        return _this;
    }
    TokenExpiredPage.prototype.onSendEmail = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isSending: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.resendEmail(key)];
                    case 2:
                        _a.sent();
                        this.setState({
                            isSendEmail: true,
                            isSending: false
                        }, function () {
                            if (_this.state.isResidentScheduleOptimization) {
                                window.location.hash = "/ResidentScheduleOptimization/EmailToSchedule/tokenExpired";
                            }
                            else {
                                window.location.hash = "/emailToSchedule/tokenExpired";
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({ isSending: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenExpiredPage.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b;
        this.props.getCopilotLink();
        if (this.state.isResidentScheduleOptimization) {
            this.setState({ callCenter: '' });
            var token = (_b = (_a = getUrlParams()) === null || _a === void 0 ? void 0 : _a.token) === null || _b === void 0 ? void 0 : _b.split("?")[0];
            if (token) {
                this.props.getCurrentUser().then(function () {
                    var _a;
                    _this.setState({ callCenter: (_a = _this.props.currentUser) === null || _a === void 0 ? void 0 : _a.clientCallCenterNumber });
                });
            }
        }
    };
    TokenExpiredPage.prototype.render = function () {
        var _this = this;
        var _a = this.props, location = _a.location, history = _a.history, copilotLink = _a.copilotLink;
        var _b = qs.parse(location.search, { ignoreQueryPrefix: true }), key = _b.key, token = _b.token;
        var isShowPhoneInfo = !key && !this.state.isSendEmail;
        if (this.state.isResidentScheduleOptimization) {
            isShowPhoneInfo = !token && !this.state.isSendEmail;
        }
        var sendEmailTxt = React.createElement("p", null, this.state.isResidentScheduleOptimization ? 'Your new link is on the way!' : 'Email has been send.');
        var copilotLinkText = copilotLink && React.createElement(React.Fragment, null,
            "or chat with us anytime at ",
            React.createElement("a", { href: copilotLink, target: "_blank" }, "Aiden"),
            ".");
        var emailBtn = this.state.isSendEmail ? sendEmailTxt : React.createElement(React.Fragment, null,
            React.createElement("button", { className: "btn btn-primary", style: { float: "left" }, disabled: this.state.isSending, onClick: function () {
                    _this.onSendEmail(key || token);
                } }, this.state.isSending ? 'Sending...' : 'Send me another link.'),
            React.createElement("br", null),
            this.state.callCenter && React.createElement("p", { style: { marginTop: 30 } },
                "If this issue continues to happen, ",
                React.createElement("br", null),
                "call us at ",
                this.state.callCenter,
                " ",
                copilotLinkText));
        var phoneTxt = this.state.callCenter && React.createElement("p", { className: "text-left" },
            "Please contact us at ",
            this.state.callCenter,
            " if you have any questions.");
        return (React.createElement("div", { className: "text-center email-invalid", style: { paddingTop: 100, marginTop: 0 } },
            React.createElement("div", { className: "common-box" },
                React.createElement("h1", null,
                    "The current link ",
                    React.createElement("br", null),
                    " has expired."),
                isShowPhoneInfo ? phoneTxt : emailBtn)));
    };
    TokenExpiredPage = __decorate([
        withRouter,
        inject(EmailToScheduleBusiness),
        observer
    ], TokenExpiredPage);
    return TokenExpiredPage;
}(Component));
export { TokenExpiredPage };
export default TokenExpiredPage;
